import React from 'react';
import styled from 'styled-components';
import { differenceInMilliseconds } from 'date-fns';

import { FormikValues, useFormikContext } from 'formik';
import MuiContainer from '@material-ui/core/Container';
import { TPostAdInitialValues } from 'src/Types';
import { ListingDetailsSchema } from 'src/utils/validationSchemas';

import AvailabilityDates from './AvailabilityDates';
import RentalPrices from './RentalPrices';
import LocationSelection from './LocationSelection';
import OtherDetails from './OtherDetails';
import Details from './Details';

interface IStyledProps {
  isActive?: boolean;
  loading?: boolean;
  selected?: boolean;
}
const Section = styled(MuiContainer)<IStyledProps>`
  display: flex !important;
  flex-direction: column;
  justify-content: ${({ loading }) => (loading && 'center') || 'flex-start'};
  align-items: flex-start;
  flex-grow: 1;
`;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
`;
/* const Loader = styled(CircularProgress)`
  color: ${({ theme }) => theme.colors.primary};
`; */

type TProps = {
  stepLoading: boolean;
  isWantedAd?: boolean;
};
const ListingDetails = ({ stepLoading, isWantedAd }: TProps) => {
  const { values } = useFormikContext<TPostAdInitialValues>();
  return (
    <Section maxWidth="sm" loading={stepLoading}>
      <Container>
        <Details />
        {!isWantedAd && <AvailabilityDates title="Select Availability Dates" />}
        <RentalPrices isWantedAd={isWantedAd} />
        <LocationSelection />
        {values.childCategory.properties.length > 0 && (
          <OtherDetails properties={values.childCategory.properties} />
        )}
      </Container>
    </Section>
  );
};

ListingDetails.label = 'Listing Details';
ListingDetails.validate = (values: FormikValues) => {
  const errors: {
    [key: string]: string;
  } = {};
  if (values.childCategory) {
    values.childCategory.properties.forEach((property: any) => {
      if (property.datatype === 'integer') {
        const intgRegx = /^[0-9]+$/;
        const inputText = values[property.name];
        if (!intgRegx.test(inputText)) {
          errors[property.name] = `${property.name} should of type ${property.datatype}`;
        }
      }
      if (!values[property.name] && property.is_mandatory) {
        errors[property.name] = `Enter ${property.name}`;
      }
    });
  }
  const diff = differenceInMilliseconds(values.endDate, values.startDate);
  if (!(diff > 0)) {
    errors.startDate = 'Please Select another date. Start date and End date should not be same';
  }
  if (!values.address) {
    errors.address = 'Please Select location';
  }
  return errors;
};
ListingDetails.validationSchema = ListingDetailsSchema;
ListingDetails.initialValues = {
  title: '',
  description: '',
  expectedPrice: '',
  rentValue: '',
  startDate: new Date(),
  endDate: new Date(new Date().getTime() + 24 * 60 * 60 * 1000),
  isNegotiable: true,
  address: '',
  place_id: null,
  condition: 'New',
  rentPer: 'day',
  rentPeriod: '',
};

export default ListingDetails;
